import React, { useEffect, useMemo } from "react";
import MeasureLayer from "../layers/measureTool";
import { LayerConfig, LayerHook, LayerHookBuilder } from "./types";
import { isMapCanvasTarget } from "./utils";

export type MeasureToolLayerConfig = LayerConfig<
  never,
  { longitude: number; latitude: number } | undefined
>;

const useMeasureHook: LayerHookBuilder<MeasureToolLayerConfig> = ({
  config,
  helpers,
}) => {
  useEffect(() => {
    if (config.interactive?.click) {
      helpers.emit({ type: "setCursor", data: "crosshair" });
    } else {
      helpers.emit({ type: "setCursor", data: "grab" });
    }
  }, [config.interactive?.click]);

  return useMemo<LayerHook>(() => {
    return {
      // we want the tool to always hover above everything to intercept all clicks
      zIndex: -2,
      render: () => {
        return <MeasureLayer key="measure-tool" />;
      },
      canHandleHover: () => !!config.interactive?.hover,
      canHandleClick: () => !!config.interactive?.click,
      onClick: ({ event }) => {
        const target = event.originalEvent.target as HTMLElement;
        if (isMapCanvasTarget(target)) {
          const { lng, lat } = event.lngLat;
          if (lng && lat) {
            config.onClick?.({
              longitude: lng,
              latitude: lat,
            });
          } else {
            config.onClick?.(undefined);
          }
        }
        return true;
      },
    };
  }, [config]);
};

export default useMeasureHook;
